export default {
  title: 'CSV prenotazioni',
  buttons: {
    generate: 'Genera e scarica',
  },
  fields: {
    date_range: 'Intervallo date (facoltativo)',
  },
  errors: {
    invalid_date_range: 'Seleziona un intervallo di date valido',
  },
};
